import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withUnit from '../utils/with-unit';

const defaultStyles = {};

function PanelGroup({
  height = 'auto',
  className = '',
  rootRef = null,
  children,
  style = defaultStyles,
  ...otherProps
}) {
  const classes = classNames('ws-panel-group', className);

  return (
    <div
      className={classes}
      style={{ ...style, height: withUnit(height) }}
      ref={rootRef}
      {...otherProps}
    >
      {children}
    </div>
  );
}

PanelGroup.propTypes = {
  rootRef: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.shape(),
  children: PropTypes.node.isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PanelGroup;
